import { Route, Routes } from "react-router-dom";

import { RouteAuth } from "@/_old/components/auth/route";
import { lazy } from "react";

const MyOfficesPage = lazy(() => import("@/my-offices/view"));

const MyOfficesRoutes = () => {
  return (
    <Routes>
      <Route
        index
        element={
          <RouteAuth permissions={["read-private-rooms"]}>
            <MyOfficesPage />
          </RouteAuth>
        }
      />
    </Routes>
  );
};

export { MyOfficesRoutes };
